import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router";
import { usePermission } from "@how/app-kit";

export type CheckInTab = "door" | "rooms" | "doors";

const PATHS: Record<CheckInTab, string> = {
  door: "/check-in",
  rooms: "/check-in/rooms",
  doors: "/check-in/doors",
};

/**
 * The Check-in section's tabs: the door (the station), Rooms and Doors. Rooms and Doors are offered to those who
 * manage events, the permission the database asks of whoever changes a room or a door; the door to those who check
 * in, which the route enforces.
 */
export function CheckInTabs({ active }: { readonly active: CheckInTab }) {
  const navigate = useNavigate();
  const manage = usePermission("events.manage", { write: true });
  const checkIn = usePermission("events.check_in");
  const showManage = manage.data === true || active !== "door";
  const showDoor = checkIn.data === true || active === "door";
  if (!showManage || !showDoor) return null;
  return (
    <Tabs
      value={active}
      onChange={(value) => {
        if (value !== null && value in PATHS) void navigate(PATHS[value as CheckInTab]);
      }}
      mb="lg"
    >
      <Tabs.List>
        <Tabs.Tab value="door">Station</Tabs.Tab>
        <Tabs.Tab value="rooms">Rooms</Tabs.Tab>
        <Tabs.Tab value="doors">Doors</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
